<template>
  <div class="flex-grow-1 white">
    <div>
      <v-breadcrumbs class="py-3" :items="items">
        <template #divider>
          <v-icon>arrow_forward_ios</v-icon>
        </template>
        <template #item="{ item, attrs }">
          <v-breadcrumbs-item
            v-bind="attrs"
            :to="item.href"
            :disabled="item.disabled"
            :data-cy="item.cypressData"
            exact
            exact-path
            exact-active-class="page-nav-bar__item-active"
          >
            <div class="grey--text text--darken-2 font-weight-medium">
              <div class="d-flex text-body-1 align-center">
                <v-icon
                  v-if="item.icon"
                  class="material-icons-outlined mr-1"
                >
                  {{ item.icon }}
                </v-icon>
                {{ item.text }}
              </div>
            </div>
          </v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>
    </div>
    <v-divider class="grey lighten-2" />
  </div>
</template>

<script>
export default {
  name: 'PageNavBar',
  props: {
    items: {
      type: Array,
      default: () => [
        {
          icon: 'home',
          text: 'Reviews',
          disabled: false,
          href: '/reviews',
        },
      ],
    },
  },
};
</script>

<style>
.page-nav-bar__item-active div div {
  color: var(--v-primary-base) !important;
  font-weight: 700 !important;
}
.page-nav-bar__item-active div div i {
  color: var(--v-primary-base) !important;
}
</style>
